<div class="overlay" *ngIf="isVisible" (click)="noClick.emit()"></div>
<div class="modal-container" *ngIf="isVisible">
    <ng-content></ng-content>
</div>